import { useState } from 'react'

import { Button, Alert, AlertTitle, AlertColor, Paper } from '@mui/material'

type Notification = {
  title?: string
  title2?: string
  title3?: string
  title4?: string
  message: string
  type?: AlertColor
  closeable?: boolean
}

export const Banner = ({
  title,
  title2,
  title3,
  title4,
  message,
  type = 'warning',
  closeable = true,
}: Notification) => {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true)

  return isNotificationVisible ? (
    <Paper
      elevation={1}
      sx={{
        zIndex: 10000,
        mx: 0,
        mb: 2,
      }}
    >
      <Alert
        action={
          closeable && (
            <Button
              size="small"
              onClick={() => setIsNotificationVisible(false)}
            >
              Скрыть
            </Button>
          )
        }
        severity={type}
        //        variant="filled"
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {title2 && <AlertTitle>{title2}</AlertTitle>}
        {title3 && <AlertTitle>{title3}</AlertTitle>}
        {title4 && <AlertTitle>{title4}</AlertTitle>}
        {message}
      </Alert>
    </Paper>
  ) : null
}
